import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

import type { Billing } from "~/v2/api/rest/billing";
import { MarketDataLoadingPres } from "../MarketDataLoading.pres";
import {
  type MarketDataSubscriptionDetailsReturn,
  useGetMarketDataSubscriptionDetails,
} from "../util";
import { useMarketDataOverviewController } from "./Overview.controller";
import { OverviewPres } from "./Overview.pres";

const stripePromise = loadStripe(window.env.STRIPE);

export const OverviewConnector = () => {
  const { billing, ...rest } = useGetMarketDataSubscriptionDetails();

  return (
    <Elements stripe={stripePromise}>
      {!billing ? (
        // we need to initialize controller hook with billing data
        <MarketDataLoadingPres />
      ) : (
        <OverviewConnectorWithStripe billing={billing} {...rest} />
      )}
    </Elements>
  );
};

interface OverviewConnectorWithStripeProps
  extends MarketDataSubscriptionDetailsReturn {
  billing: Billing;
}

const OverviewConnectorWithStripe = ({
  account,
  isElite,
  elitePerks,
  billing,
  plans,
  isLoading,
}: OverviewConnectorWithStripeProps) => {
  const { stripe, elements, ...rest } = useMarketDataOverviewController({
    accountId: account?.id ?? "",
    billing,
    elitePerks,
  });

  if (isLoading || !stripe || !elements || !plans) {
    return <MarketDataLoadingPres />;
  }

  return (
    <OverviewPres
      isElite={isElite}
      eliteStatus={elitePerks?.elite_status}
      hasEliteMarketData={elitePerks?.market_data ?? false}
      billing={billing}
      plans={plans}
      {...rest}
    />
  );
};
